export function DoTheseSelectionsHaveQuickPicks(selections) {
    let rtnVal = false;

    selections.forEach(selection => {
        if (selection["selectionObjectName"] !== undefined) {
            rtnVal = true;
        }
    });

    return rtnVal;
}

export function DoTheseSelectionsHaveMultiSegments(selections) {
    let rtnVal = false;

    selections.forEach(selection => {
        if (selection.segmentCombination !== undefined) {
            rtnVal = true;
        }
    });

    return rtnVal;
}